import jQuery from "jquery";
import Swiper from "swiper";
import "lightbox2";
import GoogleMap from "./includes/GoogleMap";
import { accordions } from "./includes/accordions";
import { popupModal } from "./includes/modal";
import { CountUp } from "countUp.js";

window.$ = jQuery;
window.jQuery = jQuery;

$(".swiper").each(function () {
  new Swiper(this, $(this).data("options"));
});

window.init_google_maps = function () {
  $(".google-map").each(function () {
    const schema = $(this).find(".google-map-schema");
    const result = $(this).find(".google-map-result");

    const map = new GoogleMap(result[0], schema.data("options"));

    schema.find(".google-map-marker").each((index, marker) => {
      map.addMarker({
        position: {
          lat: parseFloat(marker.dataset.lat),
          lng: parseFloat(marker.dataset.lng),
        },
      });
    });
  });
};

$(".parameter-trigger[data-parameter]").click(function () {
  const table = $(
    `.parameter-table[data-parameter-id="${this.dataset.parameter}"]`
  );

  table.addClass("is-highlighted");

  setTimeout(() => {
    table.removeClass("is-highlighted");
  }, 500);
});

const Site = {
  common: {
    init() {
      this.mobileNav();
      this.desktopNav();
      this.searchbox();
      this.portal();
      accordions(document.querySelectorAll(".hwg-accordion"));
      popupModal();
      this.countUp();
      this.rolodex();
    },

    countUp() {
      const housePointWrapper = document.querySelector(".house-points");
      const housePointHouses = document.querySelectorAll(
        ".house-points .house"
      );

      if (!!window.IntersectionObserver) {
        housePointHouses.forEach((item) => {
          item.querySelector(".score").innerHTML = 0;
        });
      }

      let handleIntersect = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let target = entry.target.querySelector(".score");
            let { score } = target.dataset;
            let demo = new CountUp(target, score);
            if (!demo.error) {
              demo.start();
            } else {
              console.error(demo.error);
            }
            observer.unobserve(entry.target);
          }
        });
      };

      let observer = new IntersectionObserver(handleIntersect, {
        rootMargin: "0px 0px -100px 0px",
        threshold: 1,
      });

      housePointHouses.forEach((item) => {
        observer.observe(item);
      });
    },

    desktopNav() {
      const toggles = document.querySelectorAll(
        ".hwg-nav__nav .hwg-nav__menu-item.has-children"
      );
      if (!toggles) return false;

      toggles.forEach(($toggle) => {
        let active = false;
        const subnav = $toggle.querySelector(".hwg-nav__nav-drop__wrapper");

        const tl = gsap.timeline({
          paused: true,
          duration: 0.25,
        });

        tl.fromTo(
          subnav,
          {
            autoAlpha: 0,
            height: 0,
          },
          {
            autoAlpha: 1,
            height: "auto",
          }
        );

        $toggle.addEventListener("click", (ev) => {
          // Stop following link
          // ev.preventDefault();

          // Close any other dropdowns
          toggles.forEach(($removeToggle) => {
            const removeSubnav = $removeToggle.querySelector(
              ".hwg-nav__nav-drop__wrapper"
            );
            if (removeSubnav) {
              gsap.to(removeSubnav, 0.25, {
                autoAlpha: 0,
                height: 0,
              });
            }
            $removeToggle.classList.remove("js-active");
          });

          // Play animation
          if (!active) {
            $toggle.classList.add("js-active");
            tl.play();
          } else {
            tl.reverse();
          }
          active = !active;
        });
      });
    },

    mobileNav() {
      const toggle = document.querySelector("#hwg-navbar__trigger");
      if (!toggle) return false;
      let active = false;
      const text = toggle.querySelector(".hwg-btn__text");
      const icon = toggle.querySelector(".hwg-btn__icon");
      const nav = document.querySelector(".hwg-mobilenav");

      const accordianGrps = document.querySelectorAll(".hwg-mobilenav__toggle");
      let activeAccordian = false;

      accordianGrps.forEach((grp) => {
        const trigger = grp.querySelector("a");
        const content = grp.querySelector("ul");
        const tl = gsap.timeline({ paused: true });

        tl.fromTo(
          content,
          {
            autoAlpha: 0,
            height: 0,
          },
          {
            autoAlpha: 1,
            height: "auto",
          }
        );
        trigger.addEventListener("click", (ev) => {
          ev.preventDefault();
          if (!activeAccordian) {
            tl.play();
          } else {
            tl.reverse();
          }
          activeAccordian = !activeAccordian;
        });
      });

      toggle.addEventListener("click", () => {
        active = !active;
        if (active) {
          toggle.classList.add("js-active");
          text.innerText = "Close";
          icon.classList.remove("fa-bars");
          icon.classList.add("fa-times");
          nav.classList.add("js-active");
        } else {
          toggle.classList.remove("js-active");
          text.innerText = "Menu";
          icon.classList.add("fa-bars");
          icon.classList.remove("fa-times");
          nav.classList.remove("js-active");
        }
      });
    },

    searchbox() {
      const html = document.documentElement;
      const searchbox = document.querySelector(".hwg-searchbox");
      const trigger = searchbox.querySelector(".hwg-btn");
      const searchInput = searchbox.querySelector("input");
      let active = false;

      trigger.addEventListener("click", () => {
        if (!active) {
          html.classList.add("js-searchbox-active");
          searchbox.classList.add("js-active");
          setTimeout(() => {
            searchInput.focus();
          }, 500);
          active = true;
        } else {
          console.log("do search");
        }
      });

      searchInput.addEventListener("blur", () => {
        if (active) {
          html.classList.remove("js-searchbox-active");
          searchbox.classList.remove("js-active");
          searchInput.value = "";
          active = false;
        }
      });
    },

    portal() {
      const portalTrigger = document.querySelectorAll(".hwg-portals__trigger");
      const portals = document.querySelector(".hwg-portals");
      if (!portalTrigger) return false;
      let active = false;
      const tl = gsap.timeline({
        paused: true,
        ease: Power2.easeOut,
      });
      tl.fromTo(
        portals,
        0.25,
        {
          autoAlpha: 0,
          height: 0,
        },
        {
          autoAlpha: 1,
          height: "auto",
        }
      );

      const offClick = (e) => {
        if (
          e.type === "click" ||
          (e.type === "keydown" &&
            (e.key === "Escape" || e.code === "Escape" || e.keyCode === 27))
        ) {
          tl.reverse();
          document.body.classList.remove("js-menu-open");
          document.removeEventListener("click", offClick);
          document.removeEventListener("keydown", offClick);
          active = !active;
        }
      };

      const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!active) {
          tl.play();
          document.body.classList.add("js-menu-open");
          document.addEventListener("click", offClick);
          document.addEventListener("keydown", offClick);
          active = !active;
        } else {
          offClick(e);
        }
      };

      portalTrigger.forEach((trigger) => {
        trigger.addEventListener("click", handleClick);
      });
    },
    rolodex() {
      const subjects = document.querySelectorAll(".hwg-curriculum__item");
      subjects.forEach((item) => {
        let active = false;
        item.addEventListener("click", () => {
          active = !active;
          if (active) {
            subjects.forEach((subject) => {
              subject.classList.remove("js-active");
            });
            item.classList.add("js-active");
          } else {
            item.classList.remove("js-active");
          }
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 255);
        });
      });
    },
  },
};

window.addEventListener("DOMContentLoaded", () => {
  Site.common.init();
  document.body.classList.forEach((item) => {
    if (item in Site) Site[item].init();
  });
});
